import PropTypes from 'prop-types';
import { Box, Heading, Text } from 'roo-ui/components';
import { CUSTOMER_SUPPORT_HOTLINE_AU } from 'config/constants';
import TelLink from 'components/TelLink';

const ContactUsWithReference = ({ caseNumber, ...styleProp }) => (
  <Box {...styleProp}>
    <Heading.h3 fontSize="lg" mb={0}>
      Any more questions?
    </Heading.h3>
    <Box pt={[2, 3]}>
      <Text fontSize="lg" color="greys.charcoal">
        Please give us a call on <TelLink color="greys.charcoal" number={CUSTOMER_SUPPORT_HOTLINE_AU} /> and quote the request reference
        number {caseNumber}.
      </Text>
    </Box>
  </Box>
);

ContactUsWithReference.propTypes = {
  caseNumber: PropTypes.string.isRequired,
};

export default ContactUsWithReference;
